import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function DialogPaper(props: any) {
  const handleClose = () => {
    props.setOpen(false);
  };

  const descriptionElementRef = React.useRef<HTMLElement>(null);
  React.useEffect(() => {
    if (props.open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [props.open]);

  const res: any = [];

  if (props.data?.userDetails) {
    res.push(
      <>
        <b>____________________________________________________</b>
        <br></br>
        <b>Informação do Usuário</b>
        <br></br>
        <b>____________________________________________________</b>
        <br></br>
      </>
    );
    const errorData =
      props.data?.userDetails[0] === "{"
        ? JSON.parse(props.data?.userDetails)
        : props.data?.userDetails;

    for (let key in errorData) {
      res.push(
        <div>
          <b>{key}:</b>
          {errorData[key]}
          <br />
        </div>
      );
    }
  }
  if (props.data?.deviceDetails) {
    res.push(
      <>
        <b>____________________________________________________</b>
        <br></br>
        <b>Informação do Dispositivo</b>
        <br></br>
        <b>____________________________________________________</b>
        <br></br>
      </>
    );
    const errorData =
      props.data?.deviceDetails[0] === "{"
        ? JSON.parse(props.data?.deviceDetails)
        : props.data?.deviceDetails;

    for (let key in errorData) {
      res.push(
        <div>
          <b>{key}:</b>
          {errorData[key]}
          <br />
        </div>
      );
    }
  }
  if (props.data?.conectionDetails) {
    res.push(
      <>

        <b>____________________________________________________</b>
        <br></br>
        <b>Informação da Conexão</b>
        <br></br>
        <b>____________________________________________________</b>
        <br></br>
      </>
    );

    const errorData =
      props.data?.conectionDetails[0] === "{"
        ? JSON.parse(props.data?.conectionDetails)
        : props.data?.conectionDetails;

    for (let key in errorData) {
      res.push(
        <div>
          <b>{key}:</b>
          {errorData[key]}
          <br />
        </div>
      );
    }
  }
  if (props.data?.localizationDetails) {
    res.push(
      <>

        <b>____________________________________________________</b>
        <br></br>
        <b>Informação da Localização</b>
        <br></br>
        <b>____________________________________________________</b>
        <br></br>
      </>
    );
    const errorData =
      props.data?.localizationDetails[0] === "{"
        ? JSON.parse(props.data?.localizationDetails)
        : props.data?.localizationDetails;

    for (let key in errorData) {
      res.push(
        <div>
          <b>{key}:</b>
          {errorData[key]}
          <br />
        </div>
      );
    }
  }
  if (props.data?.errorDetails) {
    res.push(
      <>

        <b>____________________________________________________</b>
        <br></br>
        <b>Informações do Erro</b>
        <br></br>
        <b>____________________________________________________</b>
        <br></br>
      </>
    );
    const errorData =
      props.data?.errorDetails[0] === "{"
        ? JSON.parse(props.data?.errorDetails)
        : props.data?.errorDetails;

    for (let key in errorData) {
      res.push(
        <div>
          <b>{key}:</b>
          {errorData[key]}
          <br />
        </div>
      );
    }
  }

  return (
    <div>
      <Dialog
        maxWidth={"xl"}
        open={props.open}
        onClose={handleClose}
        scroll={"paper"}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">Detalhes do Log</DialogTitle>
        <DialogContent dividers={true}>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
          >
            {res}
          </DialogContentText>
        </DialogContent>
        {/* <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleClose}>Subscribe</Button>
        </DialogActions> */}
      </Dialog>
    </div>
  );
}
